import VueRouter from 'vue-router'
import router from '@/routes'
import { startsWith } from 'lodash'
import Auth from '@/services/Auth'

export function getAnchor(url) {
  const a = document.createElement('a')
  a.href = url
  return a
}

export function getFullUrl(url) {
  const a = document.createElement('a')
  a.href = url
  return a.href
}

export const apiRouter = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/startups/:startupId/:linkId', name: 'startupPrivateDetails' },
  ],
})

window.apiRouter = apiRouter

export function resolveApiUrl(name, params = {}) {
  const route = apiRouter.resolve({ name, params })
  return route.href
}

export function resolveUrl(name, params = {}) {
  const route = router.resolve({ name, params })
  return route.href
}

export function resolveFullUrl(name, params = {}) {
  const route = router.resolve({ name, params })
  return getFullUrl(route.href)
}

export function normalizeWebsiteUrl(url) {
  if (!startsWith(url, 'http')) {
    url = `http://${url}`
  }
  return url
}

export function noSchemeUrl(url) {
  return url.replace(/^https?:\/\//, '')
}

const NEW_APP_PORT = 9001

export function getNewAppUrl(url, queryParams = {}) {
  const anchor = getAnchor(url)
  if (anchor.hostname === 'localhost') {
    anchor.port = NEW_APP_PORT
    const query = getQueryParams(anchor.search)
    const newQuery = {
      ...query,
      authToken: Auth.getAuthToken(),
      ...queryParams,
    }
    anchor.search = queryParamsToSearchString(newQuery)
  }
  return anchor.href
}

export function getQueryParams(searchString) {
  if (searchString.startsWith('?')) {
    searchString = searchString.substring(1)
  }
  const pairs = searchString
    .split('&')
    .map((p) => p.split('='))
    .filter((p) => p.length === 2)
  return Object.fromEntries(pairs)
}

export function queryParamsToSearchString(query) {
  return Object.keys(query)
    .map((key) => `${key}=${query[key]}`)
    .join('&')
}
